/* Supra: theme toggle, scroll reveal, mobile menu, header measuring and cart count mirror. */
(function () {
  'use strict';

  var root = document.documentElement;
  var KEY = 'supra-theme';
  var COLORS = { light: '#FAF3EC', dark: '#15131C' };
  var fadeTimer;

  function saved() {
    try {
      var value = localStorage.getItem(KEY);
      return value === 'dark' || value === 'light' ? value : null;
    } catch (e) {
      return null;
    }
  }

  function apply(theme) {
    root.setAttribute('data-theme', theme);
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', COLORS[theme]);
    var buttons = document.querySelectorAll('[data-sg-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
      buttons[i].setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
    }
  }

  /* Clicks: theme toggle and mobile menu */
  function openMenu() {
    var menu = document.getElementById('sg-menu');
    if (!menu || menu.open) return;
    menu.showModal();
    root.setAttribute('scroll-lock', '');
  }

  function closeMenu() {
    var menu = document.getElementById('sg-menu');
    if (menu && menu.open) menu.close();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-sg-theme-toggle]')) {
      var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      root.classList.add('sg-theme-fading');
      apply(next);
      try {
        localStorage.setItem(KEY, next);
      } catch (e) {}
      clearTimeout(fadeTimer);
      fadeTimer = setTimeout(function () {
        root.classList.remove('sg-theme-fading');
      }, 450);
      return;
    }

    if (target.closest('[data-sg-menu-open]')) {
      openMenu();
      return;
    }

    if (target.closest('[data-sg-menu-close]')) {
      closeMenu();
      return;
    }

    var menu = document.getElementById('sg-menu');
    if (menu && menu.open && (target === menu || target.closest('#sg-menu a[href]'))) closeMenu();
  });

  document.addEventListener(
    'close',
    function (event) {
      if (event.target && event.target.id === 'sg-menu') root.removeAttribute('scroll-lock');
    },
    true
  );

  /* Follow the phone setting until the shopper picks a side */
  if (window.matchMedia) {
    var query = window.matchMedia('(prefers-color-scheme: dark)');
    var onChange = function (event) {
      if (!saved()) apply(event.matches ? 'dark' : 'light');
    };
    if (query.addEventListener) query.addEventListener('change', onChange);
  }

  /* Scroll reveal */
  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }

  function watch() {
    var nodes = document.querySelectorAll('[data-sg-reveal]:not(.is-in):not([data-sg-watched])');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-sg-watched', '');
      if (observer) observer.observe(nodes[i]);
      else nodes[i].classList.add('is-in');
    }
  }

  /* Header height variables used by sticky content (Horizon reads these names) */
  function measureHeader() {
    var group = document.getElementById('header-group');
    if (!group) return;
    var header = group.querySelector('.sg-header');
    var headerHeight = header ? header.offsetHeight : group.offsetHeight;
    root.style.setProperty('--header-height', headerHeight + 'px');
    root.style.setProperty('--header-group-height', group.offsetHeight + 'px');
    root.style.setProperty('--sticky-header-offset', headerHeight + 'px');
  }

  /* Mirror the header cart count into the bottom bar */
  function syncCart() {
    var source = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
    var targets = document.querySelectorAll('[data-sg-cart-count]');
    if (!source || !targets.length) return;
    var text = (source.textContent || '').trim();
    var empty = source.classList.contains('hidden') || text === '0';
    for (var i = 0; i < targets.length; i++) {
      targets[i].textContent = text === '' ? '99+' : text;
      if (empty) targets[i].setAttribute('hidden', '');
      else targets[i].removeAttribute('hidden');
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      watch();
      syncCart();
    });
  }

  apply(root.getAttribute('data-theme') || 'light');
  watch();
  measureHeader();
  syncCart();

  var group = document.getElementById('header-group');
  if (group && 'ResizeObserver' in window) new ResizeObserver(measureHeader).observe(group);
  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', function () {
    measureHeader();
    schedule();
  });
  window.__sgReady = true;
})();
